import { useEffect } from "react";
import { useUsuario } from "../../providers/usuarioProvider";
import { Perfil } from "../../models/enum";
import { useTermosAceitos } from "./ui/termoDeAceite";
import { useTour } from "@reactour/tour";

export default function FelixTour() {
  const { setIsOpen, setSteps } = useTour();
  const { usuario, claims } = useUsuario();
  const { termosAceitos, loadingAceite, isContadorSemDados } =
    useTermosAceitos();

  useEffect(() => {
    if (!loadingAceite && !isContadorSemDados) {
      setIsOpen(!!usuario?.tour && termosAceitos);
    }
  }, [usuario?.tour, termosAceitos, loadingAceite, isContadorSemDados]);

  useEffect(() => {
    if (!!claims?.perfil && !!setSteps) {
      switch (claims.perfil) {
        case Perfil.INVESTIDOR:
          setSteps([
            {
              selector: ".boas-vindas",
              content: "Boas vindas à Felix na Bolsa.",
            },
            {
              selector: ".conexao",
              content: "Seu primeiro passo é importar suas operações.",
            },
            {
              selector: ".arquivo",
              content: "Suas notas são salvas no seu Arquivo.",
            },
            {
              selector: ".calculos",
              content: "Acompanhe os seus cálculos.",
            },
            {
              selector: ".timeline",
              content: "Todos os seus meses estarão na sua Timeline.",
            },
            {
              selector: ".declaracao",
              content: "E todos os seus relatórios de Declaração estarão aqui.",
            },
            {
              selector: ".comecar",
              content:
                "Agora você está pronto para começar a simplificar sua vida na Bolsa!",
            },
          ]);
          break;
        case Perfil.CONTADOR:
          setSteps([
            {
              selector: ".boas-vindas",
              content: "Boas vindas à Felix na Bolsa.",
            },
            {
              selector: ".clientes",
              content: "Todos os clientes do seu escritório estão aqui.",
            },
            {
              selector: ".clienteSelecionado",
              content:
                "Seu cliente selecionado é mostrado no canto superior direito.",
            },
            {
              selector: ".arquivo",
              content: "As operações de seus clientes são salvas no Arquivo.",
            },
            {
              selector: ".timeline",
              content:
                "E a apuração mensal de cada cliente estará na Timeline.",
            },
            {
              selector: ".declaracao",
              content:
                "E os relatórios de Declaração dos seus clientes estarão aqui.",
            },
            {
              selector: ".comecar",
              content:
                "Agora seu escritório já está preparado para atender seus clientes com poucos minutos por mês!",
            },
          ]);
          break;

        default:
          break;
      }
    }
  }, [claims?.perfil]);

  return null;
}
